// removed by extract-text-webpack-plugin
module.exports = {"paymentRow":"Xkv2lis7unwuarGD-6wRp"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/PaymentOption/AdyenPayPalComponentStyle.scss
// module id = 972
// module chunks = 0